import { render, staticRenderFns } from "./RasioEdit.vue?vue&type=template&id=e29bf4f8&scoped=true"
import script from "./RasioEdit.vue?vue&type=script&lang=js"
export * from "./RasioEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29bf4f8",
  null
  
)

export default component.exports